module.exports = __webpack_public_path__ + "favicon-900a0e0865455c00d06a95a9b429fa5b.ico";